import { colors, Typography } from "@mui/material";
import Countdown from "react-countdown";
import { t } from 'i18next';

interface IProps {
  countdown: Date;
  onComplete?: () => void;
}

export const TimerComponent: React.FC<IProps> = ({countdown, onComplete}) => (
    <>
      <Typography color={colors.blue}>{t('smsValidationMessage')}</Typography>
      <Typography color={colors.orange}>
        <Countdown
          renderer={({ minutes, seconds }) => {
            return `${minutes.toString().padStart(2, '0')}:${seconds
              .toString()
              .padStart(2, '0')}`;
          }}
          onComplete={onComplete}
          date={countdown}
        ></Countdown>
      </Typography>
    </>
  );
